/**
 * `YYYY-MM-DDTHH:MI:SSOF:00` 形式の日時文字列を `YYYY/MM/DD` または `YYYY/MM/DD hh:mm:ss` 形式に変換して返す。
 * 変換時のタイムゾーンはユーザのシステム設定に基づく。
 * @param {string} input - `YYYY-MM-DDTHH:MI:SSOF:00` 形式の日時文字列
 * @param {string} type - 変換の種類 (date/datetime)
 * @returns {string} 日時文字列から変換された文字列
 */
const formatDate = (input, type = 'date') => {
  const date = new Date(input);

  const datePart = date
    .toLocaleDateString('ja-JP')
    .split('-')
    .join('/');

  switch (type) {
    case 'date':
      return datePart;
    case 'datetime':
      const timePart = date.toLocaleTimeString('ja-JP');
      return `${datePart} ${timePart}`;
    default:
      return '-';
  }
};

export default formatDate;
